<template>
    <div class="enocare-website">
        <layout/>
    </div>
</template>

<script>
	import layout from './components/layout/layout'
    export default {
        name: 'app',
		components:{ layout },
        data() {
            return {}
        },
        watch: {
            $route(to, from) {
                this.$store.commit('changeRoute', to);
            }
        },
    }
</script>

<style lang="less">
</style>
